import { MatPaginator, MatPaginatorIntl } from '@angular/material';

export class DulorenPaginator extends MatPaginatorIntl {
  constructor() {
    super();
    this.nextPageLabel = 'Próxima Página';
    this.previousPageLabel = 'Página Anterior';
    this.itemsPerPageLabel = 'Itens por página';
    this.firstPageLabel = 'Primeira Página';
    this.lastPageLabel = 'Ultima Página';
    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      const firstItemNumber = page*pageSize+1
      const lastItemNumber = firstItemNumber+pageSize-1;
      return `${firstItemNumber} - ${lastItemNumber} de ${length}`
    }
  }
}
